import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  useColorModeValue,
  Button,
  SimpleGrid,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { TiltCard } from "../../common/TiltCard";
import { usePublicGlassSurface } from "../../common/publicVisual";
import { gtagReportConversionThenNavigate } from "../../../utils/googleAdsPageViewConversion";

const IDEAS = [
  { title: "Freelancer week", hint: "Projects + portfolio + chores" },
  { title: "Flatmates & bills", hint: "Chores + split groups + calendar" },
];

const TemplatesIndex = () => {
  const navigate = useNavigate();
  const muted = useColorModeValue("gray.600", "gray.400");
  const deep = useColorModeValue("gray.900", "white");
  const glass = usePublicGlassSurface();

  return (
    <Box as="main" bg="transparent" py={{ base: 10, md: 16 }} minH="70vh">
      <Container maxW="container.md" px={{ base: 4, md: 6 }}>
        <VStack spacing={6} align="stretch">
          <TiltCard tilt={6} borderRadius="2xl" borderWidth="1px" p={{ base: 6, md: 8 }} sx={{ transformStyle: "preserve-3d" }} {...glass}>
            <VStack spacing={4} align="stretch">
              <Heading as="h1" size="xl" color={deep}>
                Template gallery
              </Heading>
              <Text color={muted} fontSize="md" lineHeight="tall">
                One-click presets are still on the roadmap. For now, create a workspace and organise modules yourself—these combos
                mirror what early users assemble by hand:
              </Text>
            </VStack>
          </TiltCard>
          <SimpleGrid columns={{ base: 1, sm: 2 }} spacing={4}>
            {IDEAS.map((row) => (
              <TiltCard
                key={row.title}
                tilt={10}
                p={5}
                borderRadius="xl"
                borderWidth="1px"
                sx={{ transformStyle: "preserve-3d" }}
                {...glass}
              >
                <Text fontWeight="semibold" fontSize="sm" mb={1}>
                  {row.title}
                </Text>
                <Text fontSize="xs" color={muted}>
                  {row.hint}
                </Text>
              </TiltCard>
            ))}
          </SimpleGrid>
          <Button
            colorScheme="teal"
            alignSelf="flex-start"
            type="button"
            onClick={() => gtagReportConversionThenNavigate(navigate, "/register")}
          >
            Start free workspace
          </Button>
        </VStack>
      </Container>
    </Box>
  );
};

export default TemplatesIndex;
